/*jshint ignore:start*/
(function () {
	"use strict";

	function Box2D() {
		this.container = null;
		this.debugContainer = null;
		this.ground = null;

		this.entities = [];
		this.bodies = [];
		this.namedEntities = {};
		this._deferredKill = [];
		this.staticEntities = [];

		this.selectedBody = null;

		this.autoSort = false;
		this.sortBy = null;
		this.cellSize = 64;
		this._doSortEntities = false;
		this.offsetX = 0;
		this.offsetY = 0;
	}

	var p = Box2D.prototype;

	p.createWorld = function (gx, gy) {
		this.world = new b2.b2World(new b2.b2Vec2(gx, gy), false);
		b2.b2Settings.b2_angularSleepTolerance = 0.07; // 0.03490658503988659
		b2.b2Settings.b2_linearSleepTolerance = 0.02; // 0.01
		b2.b2Settings.b2_timeToSleep = 0.25; // 0.5
		this.world.SetContinuousPhysics(true);
		this.world.controller = this;
		return this.world;
	};

	p.drawDebug = function (container, stage) {
		var canvas = document.createElement('canvas');
		canvas.width = stage.canvas.width;
		canvas.height = stage.canvas.height;

		var context = canvas.getContext("2d");
		context.translate(cm.app.display.width / 2, cm.app.display.height / 2);

		this.debugBitmap = new cjs.Bitmap(canvas).set({ regX: cm.app.display.width / 2, regY: cm.app.display.height / 2 });

		var debugDrawer = new b2.b2DebugDraw();
		debugDrawer.SetSprite(context);
		debugDrawer.SetDrawScale(b2.b2Scale);
		debugDrawer.SetFillAlpha(0.5);
		debugDrawer.SetLineThickness(1);
		debugDrawer.SetFlags(b2.b2DebugDraw.e_shapeBit | b2.b2DebugDraw.e_jointBit | b2.b2DebugDraw.e_centerOfMassBit);
		this.world.SetDebugDraw(debugDrawer);

		this._debugDraw = debugDrawer;
		this._debugCtx = context;
		this._debugCanvas = canvas;
		container.addChild(this.debugBitmap);

		return context;
	};

	p.spawnEntity = function (type, x, y, container, settings) {
		var EntityClass = typeof (type) === 'string' ? cm.global[type] : type;
		if (!EntityClass) {
			throw ("Can't spawn entity of type " + type);
		}

		var ent = new (EntityClass)(this.world, x, y, container, settings);
		this.entities.push(ent);
		if (ent.name) {
			this.namedEntities[ent.name] = ent;
		}

		return ent;
	};

	p.removeAllEntities = function () {
		for (var i = 0, l = this.staticEntities.length; i < l; i++) {
			var ent = this.staticEntities[i];
			this.world.DestroyBody(ent);
		}

		for (var i = 0, l = this.entities.length; i < l; i++) {
			var ent = this.entities[i];
			this.removeEntity(ent);
		}
	};

	p.removeEntity = function (ent) {
		// Remove this entity from the named entities
		if (ent.name) {
			delete this.namedEntities[ent.name];
		}
		if(ent && ent.displayObject){
			cm.ViewControl.current.removeChild(ent.displayObject);
		}
		// ent.removeDisplayObjects();

		// We can not remove the entity from the entities[] array in the midst
		// of an update cycle, so remember all killed entities and remove
		// them later.
		// Also make sure this entity doesn't collide anymore and won't get
		// updated or checked
		ent._killed = true;
		this._deferredKill.push(ent);
	};

	p.createCeiling = function (x, y, width, height) {
		var b2Scale = b2.b2Scale;

		var fixture = new b2.b2FixtureDef();
		fixture.shape = new b2.b2PolygonShape();
		fixture.shape.SetAsBox((width * 0.5) / b2Scale, (height * 0.5) / b2Scale);
		fixture.density = 1;
		fixture.friction = 2;
		fixture.restitution = 0;

		var bodyDef = new b2.b2BodyDef();
		bodyDef.position.Set(x / b2Scale, y / b2Scale);

		var body = this.world.CreateBody(bodyDef);
		body.CreateFixture(fixture);
		body.SetType(b2.b2Body.b2_staticBody);
		body.SetUserData({ isGround: true });

		this.ceiling = body;
		this.staticEntities.push(body);
	};

	p.createWall = function (x, y, width, height) {
		var b2Scale = b2.b2Scale;

		var fixture = new b2.b2FixtureDef();
		fixture.shape = new b2.b2PolygonShape();
		fixture.shape.SetAsBox((width * 0.5) / b2Scale, (height * 0.5) / b2Scale);
		fixture.density = 1;
		fixture.friction = 2;
		fixture.restitution = 0;

		var bodyDef = new b2.b2BodyDef();
		bodyDef.position.Set(x / b2Scale, y / b2Scale);

		var body = this.world.CreateBody(bodyDef);
		body.CreateFixture(fixture);
		body.SetType(b2.b2Body.b2_staticBody);
		body.SetUserData({ isGround: true });
		this.staticEntities.push(body);
	};

	p.createGround = function (x, y, width, height) {
		var b2Scale = b2.b2Scale;

		var fixture = new b2.b2FixtureDef();
		fixture.shape = new b2.b2PolygonShape();
		fixture.shape.SetAsBox((width * 0.5) / b2Scale, (height * 0.5) / b2Scale);
		fixture.density = 1;

		fixture.friction = 99999999999999;
		fixture.restitution = 0;

		var bodyDef = new b2.b2BodyDef();
		bodyDef.position.Set(x / b2Scale, y / b2Scale);

		var body = this.world.CreateBody(bodyDef);
		body.CreateFixture(fixture);
		body.SetType(b2.b2Body.b2_staticBody);
		body.SetUserData({ isGround: true });

		this.ground = body;
		this.staticEntities.push(body);
	};
	p.destroyGround = function () {
		if(this.ground)
			this.world.DestroyBody(this.ground);
		if(this.ceiling)
			this.world.DestroyBody(this.ceiling);
	};

	p.getEntityByName = function (name) {
		return this.namedEntities[name];
	};

	p.getEntitiesByType = function (type) {
		var entityClass = typeof (type) === 'string' ? cm.global[type] : type;
		var a = [];
		for (var i = 0; i < this.entities.length; i++) {
			var ent = this.entities[i];
			if (ent instanceof entityClass && !ent._killed) {
				a.push(ent);
			} test
		}
		return a;
	};

	p.sortEntities = function () {
		this.entities.sort(this.sortBy);
	};

	p.sortEntitiesDeferred = function () {
		this._doSortEntities = true;
	};

	p.update = function (delta, event) {
		var velocityIterations = 100;
		var positionIterations = 1;
		var tick = cm.main.tick
		this.world.Step(tick, velocityIterations, positionIterations);
		this.world.ClearForces();
		// update entities
		var l = this.entities.length;
		for (var i = 0; i < l; i++) {
			var ent = this.entities[i];
			// if (ent && !ent._killed && ent._active) {
			ent.update(tick, event);
			// }
		}

		// remove all killed entities
		var n = this._deferredKill.length;
		if (n) {
			for (var i = 0; i < n; i++) {
				var ent = this._deferredKill[i];
				this.world.DestroyBody(ent.body);
				this.entities.erase(ent);
			}
			this._deferredKill.length = 0;
		}

		// sort entities?
		if (this._doSortEntities || this.autoSort) {
			this.sortEntities();
			this._doSortEntities = false;
		}

		if (this.bodies.length > 0) {
			for (var i = 0, l = this.bodies.length; i < l; i++) {
				var body = this.bodies[i];
				var vel = body.GetLinearVelocity();
				var ang = body.GetAngularVelocity();
				if (vel.x <= 0.001 && vel.y <= 0.001 && ang <= 0.01 && vel.x >= -0.001 && vel.y >= -0.001 && ang >= -0.01) {
					if (!body.isSelected && !body.m_joint) {
							body.SetAwake(false);
							body.isSelected = false;
					}
				}
			}
		}

		this.world.DrawDebugData();
	};

	p.checkBodyPost = function (body) {
		var vel = body.GetLinearVelocity();
		body.tweenCheck = null;
		if (vel.x <= 0.2 && vel.y <= 0.2)
			if (!body.isSelected) {
				body.SetAwake(false);
			}
	};

	p.jointBodies = function(bodA, bodB)
	{
		var def = new b2.b2RevoluteJointDef();
			def.bodyA = bodA.body;
			def.bodyB = bodB.body;
			def.collideConnected = true;
			def.dampingRatio = 100;
			def.localAnchorA.Set(0,-0.4);
			def.localAnchorB.Set(0,0);
			def.upperAngle = Math.toRad(100);
			def.lowerAngle = Math.toRad(70);
			def.referenceAngle= Math.toRad(90);
			def.enableLimit = false;
			bodB.body.m_joint = bodA.body.m_joint = this.world.CreateJoint(def);
	};

	p.mouseMove = function (e) {
		var Mouse = { x: e.stageX - cm.app.display.width / 2, y: e.stageY - cm.app.display.height / 2 },
			scale = b2.b2Scale,
			mousePt = new b2.b2Vec2(Mouse.x / scale, Mouse.y / scale);

		if (this.mouse_joint)
			this.mouse_joint.SetTarget(mousePt);
	};

	p.destroyMouseJoint = function (e) {
		if (this.mouse_joint) {
			this.world.DestroyJoint(this.mouse_joint);
			this.mouse_joint = false;
			for (var i = 0, l = this.bodies.length; i < l; i++) {
				var body = this.bodies[i];
				body.isSelected = false;
			}
		}
	};

	p.getBodyUnderPoint = function (pt, includeStatic) {
		var px = pt.x;
		var py = pt.y;
		var mouseVec = new b2.b2Vec2(px, py);

		var aabb = new b2.b2AABB();
		aabb.lowerBound.Set(px - 0.001, py - 0.001);
		aabb.upperBound.Set(px + 0.001, py + 0.001);

		var body = null;
		function GetBodyCallback(fixture) {
			var shape = fixture.GetShape();
			if (fixture.GetBody().GetType() != b2.b2Body.b2_staticBody || includeStatic) {
				var inside = shape.TestPoint(fixture.GetBody().GetTransform(), mouseVec);

				if (inside) {
					body = fixture.GetBody();
					return false;
				}
			}
			return true;
		}

		this.world.QueryAABB(GetBodyCallback, aabb);
		return body;
	};

	p.addContactListeners = function () {
		var b2Listener = new b2.b2ContactListener();
		this.world.SetContactListener(b2Listener);

		b2Listener.PreSolve = function (contact) {
			var fixtureA = contact.GetFixtureA();
			var bodyA = fixtureA.GetBody();
			var userDataA = bodyA.GetUserData();

			var fixtureB = contact.GetFixtureB();
			var bodyB = fixtureB.GetBody();
			var userDataB = bodyB.GetUserData();

			if (userDataA && userDataA.preSolve)
				userDataA.preSolve(bodyB, fixtureB, userDataB, bodyA, fixtureA, contact);

			if (userDataB && userDataB.preSolve)
				userDataB.preSolve(bodyA, fixtureA, userDataA, bodyB, fixtureB, contact);
		};

		b2Listener.BeginContact = function (contact) {
			var fixtureA = contact.GetFixtureA();
			var bodyA = fixtureA.GetBody();
			var userDataA = bodyA.GetUserData();

			var fixtureB = contact.GetFixtureB();
			var bodyB = fixtureB.GetBody();
			var userDataB = bodyB.GetUserData();

			if (userDataA && userDataA.beginContact)
				userDataA.beginContact(bodyB, fixtureB, userDataB, bodyA, fixtureA, contact);

			if (userDataB && userDataB.beginContact)
				userDataB.beginContact(bodyA, fixtureA, userDataA, bodyB, fixtureB, contact);
		};

		b2Listener.EndContact = function (contact) {
			var fixtureA = contact.GetFixtureA();
			var bodyA = fixtureA.GetBody();
			var userDataA = bodyA.GetUserData();

			var fixtureB = contact.GetFixtureB();
			var bodyB = fixtureB.GetBody();
			var userDataB = bodyB.GetUserData();

			if (userDataA && userDataA.endContact)
				userDataA.endContact(bodyB, fixtureB, userDataB, bodyA, fixtureA, contact);

			if (userDataB && userDataB.endContact)
				userDataB.endContact(bodyA, fixtureA, userDataA, bodyB, fixtureB, contact);
		};

		b2Listener.PostSolve = function (contact) {
			var fixtureA = contact.GetFixtureA();
			var bodyA = fixtureA.GetBody();
			var userDataA = bodyA.GetUserData();

			var fixtureB = contact.GetFixtureB();
			var bodyB = fixtureB.GetBody();
			var userDataB = bodyB.GetUserData();

			if (userDataA && userDataA.postSolve)
				userDataA.postSolve(bodyB, fixtureB, userDataB, bodyA, fixtureA, contact);

			if (userDataB && userDataB.postSolve)
				userDataB.postSolve(bodyA, fixtureA, userDataA, bodyB, fixtureB, contact);
		};
	};

	p.kill = function () {
		if (this.container) {
			this.container.removeAllEventListeners();
			this.container.removeAllChildren();
		}

		if (this._debugDraw && this.debugContainer) {
			this.debugContainer.removeAllChildren();
		}
	};
	cm.Box2D = Box2D;
})();
/*jshint ignore:end*/